module.exports = __webpack_public_path__ + "img/04.a98e38b.png";